import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { landAfterSignIn } from '../services/oauthRelay';
import './AuthPages.css';

/* The registered redirect URI, always served from the canonical frontend —
 * see the note in GoogleCallback.js. */
const FACEBOOK_REDIRECT_URI = `${window.location.origin}/auth/facebook/callback`;

export default function FacebookCallback() {
  const { facebookCodeSignIn } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setError('No authorization code received from Facebook.');
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const data = await facebookCodeSignIn(
          code, FACEBOOK_REDIRECT_URI, searchParams.get('state') || '');
        if (cancelled) return;
        landAfterSignIn(data.return_to, navigate, '/');
      } catch (err) {
        if (cancelled) return;
        setError(err.response?.data?.detail || 'Facebook sign-in failed. Please try again.');
      }
    })();

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-logo">AI Broker</div>
          <h1>Sign-in failed</h1>
          <div className="auth-error">{error}</div>
          <button className="auth-btn primary" onClick={() => navigate('/login', { replace: true })}>
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <div className="auth-logo">AI Broker</div>
        <h1>Signing you in…</h1>
        <p className="auth-subtitle">Please wait while we complete your Facebook sign-in.</p>
      </div>
    </div>
  );
}
